import React, { useState } from 'react';
import { Lock, ShieldCheck, ChevronRight, AlertCircle } from 'lucide-react';
import { ElementalLogo } from './ElementalLogo';

export const Gatekeeper = ({ onUnlock }) => {
    const [pin, setPin] = useState('');
    const [error, setError] = useState(false);
    const [shake, setShake] = useState(false);

    // --- CONFIGURATION ---
    // CHANGE THIS PIN to whatever you want your master password to be.
    // Since this is client-side code, a determined hacker could find this,
    // but it is perfect for keeping coworkers/friends out of your business.
    const MASTER_PIN = "8694"; 

    const handleSubmit = (e) => {
        e.preventDefault();
        if (pin === MASTER_PIN) {
            onUnlock();
        } else {
            setError(true);
            setShake(true);
            setPin('');
            setTimeout(() => setShake(false), 500);
        }
    };

    return (
        <div className="fixed inset-0 bg-slate-950 flex flex-col items-center justify-center p-4 z-[200]">
            <div className={`w-full max-w-sm transition-transform ${shake ? 'animate-shake' : ''}`}>
                
                {/* Logo Area */}
                <div className="flex flex-col items-center mb-8 animate-fade-in-up">
                    <div className="p-4 bg-slate-900 rounded-full border border-slate-800 mb-4 shadow-2xl shadow-emerald-900/20">
                        <ElementalLogo className="w-12 h-12 text-emerald-500" />
                    </div>
                    <h1 className="text-2xl font-bold text-white tracking-widest uppercase text-center">
                        Secure Access
                    </h1>
                    <p className="text-slate-500 text-xs mt-2 uppercase tracking-wide font-bold">
                        Restricted Area
                    </p>
                </div>

                {/* Input Area */}
                <form onSubmit={handleSubmit} className="relative group">
                    <div className={`absolute -inset-0.5 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-xl opacity-75 group-hover:opacity-100 transition duration-500 blur ${error ? 'from-red-500 to-orange-500 opacity-100' : ''}`}></div>
                    <div className="relative bg-slate-900 rounded-xl p-6 border border-slate-800 flex flex-col gap-4">
                        
                        <div>
                            <label className="text-xs font-bold text-slate-400 uppercase mb-2 block ml-1">
                                Enter Master PIN
                            </label>
                            <div className="relative">
                                <Lock className={`absolute left-3 top-3 w-5 h-5 ${error ? 'text-red-400' : 'text-slate-500'}`} />
                                <input 
                                    type="password" 
                                    value={pin}
                                    onChange={(e) => { setPin(e.target.value); setError(false); }}
                                    className="w-full bg-slate-950 border border-slate-700 rounded-lg py-3 pl-10 pr-4 text-white outline-none focus:border-emerald-500 transition-all font-mono tracking-[0.5em] text-center text-lg"
                                    placeholder="••••"
                                    autoFocus
                                    maxLength={8}
                                />
                            </div>
                        </div>

                        {error && (
                            <div className="flex items-center justify-center gap-2 text-red-400 text-xs font-bold animate-pulse">
                                <AlertCircle className="w-4 h-4" /> Access Denied
                            </div>
                        )}

                        <button 
                            type="submit"
                            className="w-full bg-white hover:bg-slate-200 text-slate-900 font-bold py-3 rounded-lg transition-all flex items-center justify-center gap-2 mt-2"
                        >
                            <ShieldCheck className="w-4 h-4" /> Unlock System
                        </button>
                    </div>
                </form>

                <p className="text-center text-[10px] text-slate-600 mt-8">
                    Four Elements Financial OS &copy; {new Date().getFullYear()}
                </p>
            </div>

            {/* Shake Animation Style Injection */}
            <style>{`
                @keyframes shake {
                    0%, 100% { transform: translateX(0); }
                    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
                    20%, 40%, 60%, 80% { transform: translateX(5px); }
                }
                .animate-shake { animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both; }
            `}</style>
        </div>
    );
};